import { requestJson } from './apiClient'
const BASE_PATH = '/api/auth'

const apiLoginService = {
  login(payload) {
    return requestJson({ method: 'POST', path: `${BASE_PATH}/login`, body: payload })
  },
  register(payload) {
    return requestJson({ method: 'POST', path: `${BASE_PATH}/register`, body: payload })
  },
  getUsers(page = 0, size = 10) {
    return requestJson({ method: 'GET', path: `${BASE_PATH}`, query: { page, size } })
  },
  updateUser(id, payload) {
    return requestJson({ method: 'PUT', path: `${BASE_PATH}/${id}`, body: payload })
  },

}

export default apiLoginService 
